export default function compressFile(options) {
  const { file, acceptFileSize, maxWidth, maxHeight, quality } = Object.assign(
    {
      acceptFileSize: 500 * 1024,
      maxWidth: 1920,
      maxHeight: 1920,
      quality: 0.9
    },
    options
  );

  return new Promise((resolve, reject) => {
    if (!/image/i.test(file.type)) {
      console.log('Cannot compress non image type');
      return resolve(file);
    }

    if (file.size <= acceptFileSize) {
      return resolve(file);
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = function (event) {
      try {
        window.URL = window.URL || window.webkitURL;
        const blobURL = window.URL.createObjectURL(file);

        const image = new Image();
        image.src = blobURL;

        image.onload = async function () {
          try {
            const canvas = document.createElement('canvas');
            let width = image.width;
            let height = image.height;

            if (width > height) {
              if (width > maxWidth) {
                height = Math.round((height *= maxWidth / width));
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width = Math.round((width *= maxHeight / height));
                height = maxHeight;
              }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                // console.log(
                //   'Resized image to ' +
                //     width +
                //     'x' +
                //     height +
                //     ', ' +
                //     (blob.size >> 10) +
                //     'kB'
                // );
                resolve(
                  new File([blob], file.name, {
                    lastModified: new Date()
                  })
                );
              },
              'image/png',
              quality
            );
          } catch (error) {
            reject(error);
          }
        };
      } catch (error) {
        reject(error);
      }
    };
  });
}
